type QueuedOperation<T> = {
  operation: () => Promise<T>;
  resolve: (value: T | PromiseLike<T>) => void;
  reject: (reason?: unknown) => void;
};

export class OperationQueue<T> {
  private queue: QueuedOperation<T>[] = [];
  private isProcessing = false;

  enqueue(operation: () => Promise<T>): Promise<T> {
    return new Promise((resolve, reject) => {
      this.queue.push({ operation, resolve, reject });
      this.processQueue();
    });
  }

  private async processQueue() {
    if (this.isProcessing || this.queue.length === 0) {
      return;
    }

    this.isProcessing = true;

    try {
      const { operation, resolve } = this.queue[0];
      const result = await operation();
      resolve(result);
    } catch (error) {
      this.queue[0].reject(error);
    } finally {
      this.queue.shift();
      this.isProcessing = false;

      if (this.queue.length > 0) {
        this.processQueue();
      }
    }
  }
}
